import { EditorExtensionEnum as e } from "./enums/editor-extensions-enum.mjs";
import { baseExtensions as t } from "./constants/default-extensions.mjs";
import { CharacterCount as n } from "./components/character-count.mjs";
import { FontFamilyEnum as r } from "./extensions/font-family-extension/utils.mjs";
import { useImageDropAndUpload as i } from "./extensions/image-extension/use-image-drop-and-upload/index.mjs";
import { useInitContentWithLinkifiedText as a } from "./extensions/link-extension/use-init-content-with-linkified-text.mjs";
import { convertStyleObjectToCss as o } from "./utils/style-helpers.mjs";
import { getExistingExtensions as s, getExtensions as c } from "./utils/get-extensions.mjs";
import { Toolbar as l } from "./toolbar/index.mjs";
import { preprocessPastedHtmlForEditor as u, useProcessContent as d } from "./utils/use-process-content.mjs";
import { FileSourceEnum as f } from "@systemeio/file-manager";
import { EditorContent as p, useEditor as m } from "@tiptap/react";
import { useEffect as h, useState as g } from "react";
import { twMerge as _ } from "tailwind-merge";
import { jsx as v, jsxs as y } from "react/jsx-runtime";
//#region src/tip-tap.tsx
var b = ({ mode: b = "html", content: x, isPreFetching: S, isEditable: C = !0, extensions: w = t, className: T, toolbarStyles: E, characterCountHint: D, style: O, toolbarClassName: k, showToolbar: A = !0, extensionOptions: j, showAllItems: M, skeletonClassName: N, defaultFont: P = r.TimesNewRoman, onBlur: F, onChange: I }) => {
	let L = j?.[e.Image]?.fileSource ?? f.TextEditor, { onDrop: R, onPaste: z } = i(L), [B, V] = g(!1), H = b === "html" ? "getHTML" : "getText", U = Array.from(new Set(w)), { hasImage: W, hasCharacterCount: G, hasSimpleLink: K } = s(U), { preprocessedContent: q, postprocessContent: J } = d(x, b), Y = m({
		content: q,
		immediatelyRender: !1,
		onCreate: () => V(!0),
		extensions: c(U, j),
		onUpdate: ({ editor: e }) => {
			if (!B) return;
			let t = e.isEmpty ? "" : e[H]();
			I(J(t));
		},
		onBlur: ({ editor: e }) => {
			if (!B || !F) return;
			let t = e.isEmpty ? "" : e[H]();
			F(J(t));
		},
		editorProps: {
			handlePaste: W ? z : void 0,
			handleDrop: W ? R : void 0,
			transformPastedHTML: b === "html" ? (e) => u(e) : void 0,
			attributes: {
				class: _("border-border-200 bg-bg-primary transition-base border", "min-h-[500px]", "w-full", "focus:outline-hidden", "focus:border-border-accent", "overflow-auto", "rounded-b-lg", !C && "pointer-events-none cursor-default", T),
				style: o({
					paddingLeft: "8px",
					paddingRight: "8px",
					fontFamily: P,
					...O
				})
			}
		}
	});
	return a({
		editor: Y,
		content: x,
		shouldInitialize: K && b === "text"
	}), h(() => {
		Y && Y.setOptions({ editable: C && !S });
	}, [
		C,
		S,
		Y
	]), h(() => {
		!Y || Y.isFocused || Y[H]() !== q && Y.commands.setContent(q, { emitUpdate: !1 });
	}, [
		q,
		Y,
		H
	]), Y?.isInitialized ? /* @__PURE__ */ y("div", {
		className: "relative",
		children: [
			A && w.length !== 0 && /* @__PURE__ */ v(l, {
				editor: Y,
				extensions: U,
				toolbarStyles: E,
				toolbarClassName: k,
				showAllItems: M,
				extensionOptions: j
			}),
			/* @__PURE__ */ v(p, { editor: Y }),
			G && /* @__PURE__ */ v(n, {
				editor: Y,
				hint: D,
				className: "mt-2 mr-2 ml-auto w-fit"
			})
		]
	}) : /* @__PURE__ */ v("div", { className: _("bg-bg-quaternary h-[500px] w-full animate-pulse rounded-lg", N) });
};
//#endregion
export { b as TipTapEditor };
